
export const TOKEN = localStorage.getItem('token');;

export const AGENTNAME = localStorage.getItem('AGENTNAME');
export const AGENTID = localStorage.getItem('AGENTID');
export const AGENTPHONE = localStorage.getItem('AGENTPHONE');
export const AGENTEMAIL = localStorage.getItem('AGENTEMAIL');


export const ROLE = localStorage.getItem('ROLE') ;